import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element #root not found');
}
createRoot(rootElement).render(_jsx(StrictMode, { children: _jsx(App, {}) }));
